import { connect } from 'react-redux'
import PresenterScreen from './PresenterScreen'
import getPresentersFromSeatingOrder from '../../dataStore/selectors/getPresentersFromSeatingOrder'
import selectFocusedPresenterDetails from '../../dataStore/selectors/selectFocusedPresenterDetails'
import selectScreenSharingPresenterDetails from '../../dataStore/selectors/selectScreenSharingPresenterDetails'
import { State } from '../../dataStore/reducers/reducerType'
import { mediaType } from '@bt-react/constants'
import { PresenterScreenProps } from './types'
import selectObservers from '../../dataStore/selectors/selectObservers'

const mapStateToProps = (state: State, props): PresenterScreenProps => ({
  presenters: getPresentersFromSeatingOrder(state),
  maxPresenters: state.config.maxPresenters,
  focusedPresenter: state.room.mediaType === mediaType.WEBCAM ? undefined : selectFocusedPresenterDetails(state),
  screenSharingPresenter: state.room.mediaType === mediaType.SCREENSHARE ? selectScreenSharingPresenterDetails(state) : undefined,
  sidebarActive: state.layouts.presenterLayout.sidebarActive,
  mediaSidebarActive: state.layouts.mediaLayout.mediaSidebarActive,
  mediaType: state.room.mediaType,
  isBridgeInstance: state.config.bridgeName !== '',
  mediaLayout: state.layouts.mediaLayout.mediaLayoutType,
  autoSpotlight: state.syncUi.autoSpotlight,
  audioMuted: props.audioMuted,
  role: state.config.role,
  observers: selectObservers(state)
})

export default connect(mapStateToProps)(PresenterScreen)
